import React, { Component } from 'react';
import { ValidationModal } from '../components/index';
import '../css/validations.css'

// import $ from 'jquery';

// const AMOUNT_FORMAT = /^\d{1,6}$/;
// const DESCRIPTION_FORMAT = /^[a-zA-ZÀ-ÿ\s]{4,50}$/;

class CashInModal extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         amountIn: '',
    //         descriptionIn: ''
    //     };
    //     this.ChangeValue = this.ChangeValue.bind(this);
    //     this.ChangeDescription = this.ChangeDescription.bind(this);
    // }

    // ChangeValue(event) {
    //     this.setState({ amountIn: event.target.value });
    // }

    // ChangeDescription(event) {
    //     this.setState({ descriptionIn: event.target.value });
    // }

    // ValidateAmount = async () => {
    //     let element = document.getElementById('amountIn');
    //     let text = document.querySelector(`#grupo__amountIn .form__input-error`);
    //     let require = document.querySelector(`#grupo__amountIn .form__input-void`);

    //     if (!this.state.amountIn == '') {

    //         if (!AMOUNT_FORMAT.test(this.state.amountIn)) {

    //             element.classList.add('form__group-incorrect');
    //             element.classList.remove("form__group-correct");
    //             text.classList.add('form__input-error-active');
    //             require.classList.remove('form__input-void-active');
    //         } else {
    //             element.classList.remove('form__group-incorrect');
    //             element.classList.add("form__group-correct");
    //             text.classList.remove('form__input-error-active');
    //             require.classList.remove('form__input-void-active');
    //         }
    //     } else {
    //         element.classList.add('form__group-incorrect');
    //         element.classList.remove("form__group-correct");
    //         require.classList.add('form__input-void-active');
    //         text.classList.remove('form__input-error-active');
    //     }
    // }

    // ValidateDescription = async () => {
    //     let element = document.getElementById('descriptionIn');
    //     let require = document.querySelector(`#grupo__amountIn .form__input-void`);
    //     if (!this.state.descriptionIn == '') {
    //         if (!DESCRIPTION_FORMAT.test(this.state.descriptionIn)) {
    //             element.classList.add('form__group-incorrect');
    //             element.classList.remove("form__group-correct");
    //             require.classList.remove('form__input-void-active');
    //         } else {
    //             element.classList.remove('form__group-incorrect');
    //             element.classList.add("form__group-correct");
    //             require.classList.remove('form__input-void-active');
    //         }
    //     } else {
    //         element.classList.add('form__group-incorrect');
    //         element.classList.remove("form__group-correct");
    //         require.classList.add('form__input-void-active');
    //     }
    // }

    // ValidateAll = async () => {
    //     this.ValidateAmount();
    //     this.ValidateDescription();
    // }

    // ValidateCashIn = async () => {
    //     this.ValidateAll();
    //     if (!this.state.amountIn ||
    //         !this.state.descriptionIn ||
    //         this.state.amountIn < 1
    //     ) {
    //         return;
    //     }
    //     $('#cashInModal').modal('hide');
    //     $('#vmCashInModal').modal('show');
    // }

    // ResetValidations = async () => {
    //     const ids = [
    //         'amountIn',
    //         'descriptionIn',
    //     ];
    //     for (let index = 0; index < ids.length; index++) {
    //         let element = document.getElementById(ids[index]);
    //         let text = document.querySelector(`#grupo__` + ids[index] + ` .form__input-error`);
    //         let require = document.querySelector(`#grupo__` + ids[index] + ` .form__input-void`);
    //         element.classList.remove("form__group-correct");
    //         element.classList.remove('form__group-incorrect');
    //         if (ids[index] != 'descriptionIn') {
    //             text.classList.remove('form__input-error-active');
    //             require.classList.remove('form__input-void-active');
    //         }

    //     }
    // }

    // ResetModal = async () => {
    //     await this.ResetValidations();
    //     this.setState({amountIn: []});
    //     this.setState({descriptionIn: []});
    // }

    // MakeCashIn= async ()=>{
    //     const {ShowRefMoveCashModal} = this.props
    //     const {cashIn} = this.props;
    //     let data={
    //         amount:this.state.amountIn, 
    //         descrip:this.state.descriptionIn,
    //         type:"in"
    //     }
    //     localStorage.setItem('lastCashMove', JSON.stringify(data));
    //     ShowRefMoveCashModal();
    //     cashIn(this.state.amountIn, this.state.descriptionIn);
    //     this.ResetModal();

    // }

    render() {
        const { cashMovementModel, ChangeComment, ChangeAmount, ShowCashInModal, SendCashMovement } = this.props
        return (
            <div>
                <div className="modal fade" id="cashInModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="cashInModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ boxShadow: "1px 1px 10px rgba(1,1,1,0.3)" }}>
                            <div className="modal-body" id="grupo__amountIn">
                                <h4>Entrada de efectivo</h4>
                                <table>
                                    <thead>
                                        <tr>
                                            <td>
                                                <h5 className="form-label pl-5">Efectivo: </h5>
                                            </td>
                                            <td>
                                                <div className="input-group pl-5 pr-5 pb-3 pt-3"  >
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="basic-addon1" style={{ backgroundColor: "#28a745", borderColor: "#28a745", color: "#fff" }}><strong>$</strong></span>
                                                    </div>
                                                    <input
                                                        id="amountIn"
                                                        type="number"
                                                        className="form-control form__input"
                                                        placeholder="0.00"
                                                        pattern="^[0-9]+"
                                                        value={cashMovementModel ? cashMovementModel.cashAmount : ''}
                                                        onChange={(event) => ChangeAmount(event.target.value)}

                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </thead>
                                </table>
                                <div id="grupo__descriptionIn">
                                    <div className="input-group pl-5 pr-5">
                                        <textarea
                                            id="descriptionIn"
                                            className="form-control form__input"
                                            aria-label="With textarea"
                                            placeholder="Descripción"
                                            value={cashMovementModel ? cashMovementModel.comment : ''}
                                            onChange={(event) => ChangeComment(event.target.value)}
                                        />
                                    </div>
                                </div>
                                <p className="form__input-error ml-5">Solo números positivos de max. 6 digitos.</p>
                                <p className="form__input-void ml-5">Ningun campo puede ir vacio.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary"  onClick={() => ShowCashInModal(false)}>Cancelar</button>
                                <button type="button" className="btn btn-success" onClick={() => SendCashMovement(1)}><i className="fa fa-plus-circle mr-2" aria-hidden="true" />Ingresar</button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <ValidationModal
                    idValidation="vmCashInModal"
                    message={"¿Seguro que quiere continuar?"}
                    idModalOrigin="#cashInModal"
                    idModalDestiny="#refMoveCashModal"
                    eventOnclick={this.MakeCashIn} />
            </div>
        );
    }
}

export default CashInModal;